$(function () {
  // 移动端
  if (isMedium) {
    newSwiper('#service--swiper', {
      loop: true,
      slidesPerView: isMobile ? 3 : 4,
      centeredSlides: true,
      nextButton: '#service--next',
      prevButton: '#service--prev'
    })

    // newSwiper('#news--swiper-1', {
    //   loop: true,
    //   slidesPerView: isMobile ? 2 : 3,
    //   spaceBetween: 5,
    //   nextButton: '#news--next-1',
    //   prevButton: '#news--prev-1'
    // })

    newSwiper('#investor--swiper', {
      loop: true,
      slidesPerView: isMobile ? 1 : 3,
      spaceBetween: 5,
      nextButton: '#investor--next',
      prevButton: '#investor--prev',
      onInit: function (swiper) {
        setTimeout(function () {
          $('#investor--swiper .dot-ellipsis').dotdotdot({
            wrap: 'letter'
          })
        }, 500)
      }
    })

  } else {
    // pc端
  }
  initNewsSwiper(1)

  // 都需要的
  newSwiper('#banner', {
    loop: true,
    autoplay: 3000, //3秒切换一次
    pagination: '#banner .swiper-pagination',
    nextButton: '#banner--next',
    prevButton: '#banner--prev'
  })


  $('.news--tabs').on('click', '.tab--item', function () {
    var that = $(this),
      idx = that.index() + 1
    that.addClass('tab--item-active')
    that.siblings().removeClass('tab--item-active')
    initNewsSwiper(idx)
  })

  function initNewsSwiper(idx) {
    var thatSwiper = $('.news--swiper').eq(idx - 1)
    thatSwiper.addClass('news--swiper-active')
    thatSwiper.siblings('.news--swiper').removeClass('news--swiper-active')
    newSwiper('#news--swiper-' + idx, {
      loop: true,
      slidesPerView: isMobile ? 2 : 4,
      spaceBetween: isMobile ? 5 : 20,
      nextButton: '#news--next-' + idx,
      prevButton: '#news--prev-' + idx,
      onInit: function (swiper) {
        setTimeout(function () {
          $('.dot-ellipsis', thatSwiper).dotdotdot({
            wrap: 'letter'
          })
        }, 500)
      }
    })
  }

  $('#video--btn').click(function () {
    var videoPlayer = $('#video--player')
    videoPlayer.show()
    videoPlayer[0].play()
  })
})